import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import { mantineCustomFieldFromNoteCellConnection } from "app/static/frontend/sheets/selectors/column-selectors"

import { CustomTagCell } from "app/static/frontend/sheets/components/cells/MantineCells"
import { CellWrapper } from "app/static/frontend/sheets/components/cells/MantineCells/CellWrapper"

/**
 * Renders a custom field originating from a Note object
 */
const CustomFieldFromNoteCellComponent = ({
    cellExists,
    customDataValue,
    children, // Pulling this out here to avoid spitting it out as the Cell's value if !cellExists
    ...props
}) => {
    if (cellExists) {
        return (
            <CustomTagCell cellValue={customDataValue} sendRowIds={true} {...props}>
                {customDataValue}
            </CustomTagCell>
        )
    } else {
        return <CellWrapper {...props} />
    }
}

CustomFieldFromNoteCellComponent.propTypes = {
    /** A TagType to determine how to render the tag */
    tagType: PropTypes.number,
    /** If false, the cell will indicate no note was found */
    cellExists: PropTypes.bool,
    /** The value of the custom field */
    customDataValue: PropTypes.any,
}

export const CustomFieldFromNoteCell = connect((state, props) =>
    mantineCustomFieldFromNoteCellConnection(state, props),
)(CustomFieldFromNoteCellComponent)
